import './App.css';
import { ComparisonProvider } from './context/ComparisonContext';
import ComparisonResult from './pages/ComparisonResult';

function App() {
  return (
    <ComparisonProvider>
      <ComparisonResult />
    </ComparisonProvider>
  );
}

export default App;
